import axios from 'axios'

const UnrollApi = axios.create({
  baseURL: process.env.REACT_APP_API,
  timeout: 60000
})

export default UnrollApi
